import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from '@app/core/store/reducers/dashboard';

const getDashboardFeatureState = createFeatureSelector<DashboardState>('dashboard');

export const getSearchText = createSelector(getDashboardFeatureState, (state: DashboardState) => state.searchText);
